<template>
    <div class="content-openimage">
        <top-nav
            @toggleLeftSideBar="showLeftSidebar = !showLeftSidebar"
            @toggleRightSideBar="showRightSidebar = !showRightSidebar"
        />

        <section class="wrap-content">
            <side-left :show="showLeftSidebar"/>

            <div class="content" :class="showLeftSidebar ? 'to-width-content-normal' : 'to-width-content-full'">
                <router-view></router-view>
            </div>

            <side-right :show="showRightSidebar"/>
        </section>
    </div>
</template>

<script>
    import TopNav from './TopNav.vue'
    import SideLeft from './SideLeft.vue'
    import SideRight from './SideRight.vue'

    export default {
        data() {
            return {
                showLeftSidebar: true,
                showRightSidebar: false
            }
        },
        components: {
            TopNav,
            SideLeft,
            SideRight
        }
    }
</script>